import React, { useState, Fragment } from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import "./DeclineModalComponent.css";
import declineShipmentModal from "../../assets/images/declineShipmentModal.png";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import xIcon from "../../assets/images/xmark.svg";
import { useDispatch } from "react-redux";
import {
  cancelOrder,
  deleteOrderById,
  fetchOrders,
} from "../../redux/orderSlice";
import {
  fetchPendingCompany,
  getPendingCompanyDetailsById,
  rejectAproveCompany,
} from "../../redux/adminSlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const RejectCompanyModalComponent = ({ forModule, companyId, action,status }) => {
  const [open, setOpen] = React.useState(false);
  const [reasonText, setReasonText] = useState("");
  const dispatch = useDispatch();

  const handleTextChange = (e) => {
    setReasonText(e.target.value);
  };

  const handleSubmit = () => {
    console.log("Text submitted:", reasonText);
    const queryParams = {
      status: 0,
      companyId: companyId,
      action: 'approve',
      rejectReason: reasonText,
    };
    dispatch(rejectAproveCompany(queryParams))
    .then((response) => {
      const queryParams = { type: "pending" };
      dispatch(getPendingCompanyDetailsById({ companyId, queryParams }));
      
      
    })
    .catch((error) => {
      console.error('Error deleting product:', error);
    })
    handleClose();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // console.log('>>> :: DecLine :: <<<', forModule, orderId,action)

  return (
    <div>
      <Fragment>
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          Decline  {forModule}
        </Button> */}
        <button
          className="btn btn-light grey-btn lg-btn me-3"
          onClick={handleClickOpen}
        >
          Reject
        </button>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          className="shipmentDeclineModalBody"
        >
          <DialogTitle
            sx={{ m: 0, p: "0px 39px " }}
            id="customized-dialog-title"
          >
            {/* Modal title */}
            <div className="modalImagediv">
              <img
                className="modalImage"
                src={declineShipmentModal}
                alt="modal"
              />
              <h4 className="headingForDeclineShipmentModal">
                {" "}
                Decline {forModule}{" "}
              </h4>
            </div>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              backgroundColor: "white",
              height: "7%",
              width: "6%",
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <Typography gutterBottom>
              <h4 className="titleHeadingForModal">
                Please provide reason for declining this {forModule}
              </h4>
              <div className="shipmentDeclineModalTextField">
                <TextField
                  label="Enter here"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "80px",
                    },
                  }}
                  value={reasonText}
                  onChange={handleTextChange}
                  margin="normal"
                />
              </div>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              style={{
                width: "400px",
                marginRight: "19%",
                marginLeft: "20%",
                backgroundColor: "lightgrey",
                textDecoration: "white",
              }}
            >
              Decline {forModule}
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </Fragment>
    </div>
  );
};
export default RejectCompanyModalComponent;
